import axios from 'axios';
import { getApiBaseUrl } from '../../config/api';
import {
    getRequest,
    getSuccess,
    getError
} from './complainSlice';

export const getAllComplains = (id, address) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${getApiBaseUrl()}/${address}List/${id}`);
        if (result.data?.message) {
            dispatch(getSuccess([]));
        } else {
            dispatch(getSuccess(Array.isArray(result.data) ? result.data : []));
        }
    } catch (error) {
        dispatch(getError(error));
    }
};

export const getTeacherComplains = (teacherId) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${getApiBaseUrl()}/ComplainList/Teacher/${teacherId}`);
        if (result.data?.message) {
            dispatch(getSuccess([]));
        } else {
            dispatch(getSuccess(Array.isArray(result.data) ? result.data : []));
        }
    } catch (error) {
        dispatch(getError(error));
    }
};
